import {
  assoc,
  curry,
  either,
  equals,
  filter,
  includes,
  isEmpty,
  isNil,
  pipe,
  propEq,
  reject,
} from "ramda";
import { isBlank, notBlank } from "../common/general";
import * as submissionReducer from "submission/submissionReducer";

const validateSubmissionFiles = curry((submissionState, fields, errors) => {
  // TODO: Tyler [2/7/2025] Recently been receiving bugsnags for "Cannot read properties of undefined (reading 'fantasy-land/filter)"
  // This usually means the value (object) provided to the ramda function is missing the intended property.
  // Not sure why this is happening, but will force reuploading files in the meantime.
  if (isBlank(submissionState.submissionFiles) || isBlank(fields.workFiles)) {
    return assoc("workFiles", ["validation_work_file_required"], errors);
  }

  // validating against both submission and work files;
  // work files keep track of "failed" and "aborted" files during upload
  const submissionFiles = reject(
    propEq("fileType", "COVER"),
    submissionState.submissionFiles
  );
  const badFiles = filter(
    file => includes(file.status, ["failed", "aborted"]),
    fields.workFiles
  );
  if (isBlank(submissionFiles) || notBlank(badFiles)) {
    return assoc("workFiles", ["validation_work_file_required"], errors);
  } else {
    return errors;
  }
});

const validateCoverFile = curry((workTypeId, { coverFile }, errors) =>
  equals(workTypeId, "ALBUM") && isEmpty(coverFile)
    ? assoc("coverFile", ["validation_work_file_required"], errors)
    : errors
);

export const validateWorkTypeId = curry((workTypeId, errors) => {
  return either(isEmpty, isNil)(workTypeId)
    ? assoc("workTypeId", ["validation_work_type_id_required"], errors)
    : errors;
});

export const validateUpload = curry((submissionState, fields) =>
  pipe(
    validateSubmissionFiles(submissionState, fields),
    validateCoverFile(submissionReducer.getWorkTypeId(submissionState), fields),
    validateWorkTypeId(submissionReducer.getWorkTypeId(submissionState))
  )({})
);
